import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {Chart} from 'chart.js';
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-inactive-patients',
  templateUrl: './bar-chart-inactive-patients.component.html',
  styleUrls: ['./bar-chart-inactive-patients.component.css']
})
export class BarChartInactivePatientsComponent implements OnInit, OnDestroy {
  // per inizializzazione
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  isDataAvailable = false;
  isInfoShowed = false;
  isTableAvailable = false;
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription5: Subscription;
  title = "Pazienti inattivi";
  destination = 'general-status';
  // elementi che servono per il bar-chart
  canvas: any;
  ctx: any;
  myChartInactivePatients: Chart;
  // ******************************************************************************************************************
  // tabella dei pazienti inattivi
  headElementsInactive = ['select', 'name', 'surname', 'lastLogin'];
  dataSourceInactivePatients = new MatTableDataSource();
  // ******************************************************************************************************************
  // seguenti righe: inizializzazione dei pazienti attivi/inatt globali
  // ******************************************************************************************************************
  inactiveGlobalStandard = 0;
  inactiveGlobalTelemedicine = 0;
  inactiveGlobal = 0;
  activeGlobalStandard = 0;
  activeGlobalTelemedicine = 0;
  standardGlobalPatients = 0;
  telemedicineGlobalPatients = 0;
  inactiveGlobalPatientsArray = [];
  activeGlobalPatientsArray = [];
  inactivePatientsGlobal = [];
  // ******************************************************************************************************************
  // bar chart dei pazienti personali attivi e inattivi personali/globali
  // ******************************************************************************************************************
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLabels = ['UTENTI:'];

  public barChartLegendGlobal = true;

      //global barChartData
  public barChartDataGlobal = [{
    data: this.inactiveGlobalPatientsArray,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: '#f00',
    hoverBackgroundColor: '#c00',
    label: 'Non attivi',
    datalabels: {
      color: 'white' // Color for percentage value
    }
  }, {
    data: this.activeGlobalPatientsArray,
    backgroundColor: 'lightgrey',
    hoverBackgroundColor: '#808080',
    barThickness: 70,  // number (pixels) or 'flex'
    label: 'Attivi',
    datalabels: {
      color: 'lightgray' 			// Make the color of the second bar percentage value same as the color of the bar
    }
  }];
  //fine globalBarChartData
  // paginator Inactive
  public pageSizeInactive = 5;
  public currentPageInactive = 0;
  public tasksInactive: any[];
  public totalSizeInactive = 0;
  // selezione Inactive Patients Global
  selectedInactive = false;
  patientInactiveMails: string[] = [];
  checkedInactive = false;
  // hover variables of Inactive
  isActiveInactiveHovered = false;
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }
  // constructor
  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private snackBar: MatSnackBar) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  // ******************************************************************************************************************
  // metodo all'inizio
  ngOnInit(): void {
    this.subscription5 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveGlobalInactiveTelemedicine();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription5.unsubscribe();
  }
  // ******************************************************************************************************************
  // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
  // e in standard e poi tutti
  // i pazienti in ogni categoria per poter calcolare gli attivi
  // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
  retrieveGlobalInactiveTelemedicine() {
    this.subscription1 = this.doctorService.getInactiveGlobalTelemedicine().subscribe(patients => {
      this.inactiveGlobalTelemedicine = Object.keys(patients).length;
      Object.keys(patients).forEach(patient => {
        this.inactivePatientsGlobal.push(patients[patient]);
      });
      this.retrieveGlobalInactiveStandard();
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }
  retrieveGlobalInactiveStandard() {
    this.subscription2 = this.doctorService.getInactiveGlobalStandard().subscribe(patients => {
      this.inactiveGlobalStandard = Object.keys(patients).length;
      this.inactiveGlobal = this.inactiveGlobalTelemedicine + this.inactiveGlobalStandard;
      Object.keys(patients).forEach(patient => {
        this.inactivePatientsGlobal.push(patients[patient]);
      }); // prova per la tabella dei pazienti inattivi
      console.log(this.inactivePatientsGlobal);
      this.retrieveGlobalTelemedicineStandardNumber();
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }

  retrieveGlobalTelemedicineStandardNumber() {
    this.subscription3 = this.doctorService.getGlobalStandardTeleMedicineNumber().subscribe(num => {
      this.standardGlobalPatients = num[0];
      this.telemedicineGlobalPatients = num[1];
      this.activeGlobalTelemedicine = this.telemedicineGlobalPatients - this.inactiveGlobalTelemedicine;
      this.activeGlobalStandard = this.standardGlobalPatients - this.inactiveGlobalStandard;

      this.inactiveGlobalPatientsArray.push(this.inactiveGlobal); // riempio il vettore del bar chart con standard
      this.activeGlobalPatientsArray.push(this.activeGlobalTelemedicine + this.activeGlobalStandard); // riempio il vettore del bar chart con telemedicina
      this.canvasSetting();
      this.isDataAvailable = true;

    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }
 
  canvasSetting() {
      this.canvas = document.getElementById('myChartInactivePatients') as HTMLCanvasElement;
      this.ctx = this.canvas.getContext('2d');
      this.myChartInactivePatients = new Chart(this.ctx, {
        type: this.barChartTypeGlobal,
        data: {
          labels: this.barChartLabels,
          datasets: this.barChartDataGlobal,
        },
        options: {
          responsive: true,
          onClick: event => {
            if (this.myChartInactivePatients.getElementAtEvent(event).length > 0) {
              if (this.myChartInactivePatients.getElementAtEvent(event)[0]['_model'].datasetLabel === 'Non attivi') {
                this.showTable();
              }
            }
          },
          onHover: (event) => {
            if (this.myChartInactivePatients.getElementAtEvent(event).length > 0) {
              if (this.myChartInactivePatients.getElementAtEvent(event)[0]['_model'].datasetLabel === 'Non attivi') {
                this.setHoverActiveInactiveVariable();
              } else {
                this.unsetHoverActiveInactiveVariable();
              }
            }
          },
          scales: {
            xAxes: [{
              display: true,
              stacked: true,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
            yAxes: [{
              display: false,
              stacked: true,
              ticks: {
                fontSize: 12,
                fontStyle: 'bold',
                fontFamily: 'Helvetica',
                fontColor: '#006192'
              }
            }],
          },
          legend: {
            onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
              // tslint:disable-next-line:max-line-length
              if (legendItem.text.length > 0 && (legendItem.text === 'Non attivi' || legendItem.text === 'Attivi')) {
                this.setHoverActiveInactiveVariable();
              } else {
                this.unsetHoverActiveInactiveVariable();
              }
            },
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              fontColor: '#006192',
              fontSize: 18,
              fontFamily: 'Helvetica',
            }
          },
          tooltips: {
            // content: '{pathology}: {number}',
            backgroundColor: '#1c1c1c',
            bodyFontSize: 18,
            titleFontSize: 18,
            cornerRadius: 5,
            caretPadding: 10
          },
          title: {
            display: true,
            text: 'N° di utenti attivi e non attivi',
            fontColor: '#006192',
            fontSize: 20,
            fontFamily: 'Helvetica',
          },
          hover: {
            mode: 'nearest',
            intersect: true
          }
        }
      });
    //fine1
      } // dopo aver ottenuto tutti i dati creo il bar chart
  // show inactive patients table
  showTable() {
    if (this.isActiveInactiveHovered === true) {
      if (this.isTableAvailable === true) {
        this.isTableAvailable = false;
      } else {
        this.getPaginationInactive();
        this.isTableAvailable = true;
      }
    }
  }
  // nasconde la tabella degli inattivi
  hideTable() {
    this.isTableAvailable = false;
  }
  // invia le mail agli utenti inattivi selezionati
  sendMailInactive() {
    this.doctorService.sendMailtoInactive(this.patientInactiveMails).subscribe(response => {
      if (response.status === 200) {
        this.snackBar.open('E-mail inviata/e correttamente!', 'Chiudi', {
          duration: 3000});
      } else {
        this.snackBar.open('Qualcosa è andato storto!', 'Chiudi', {
          duration: 3000});
      }
    });
  }
  // pagination della tabella degli inattivi
  // la paginazione è stata effettuata manualmente
  getPaginationInactive() {
    this.dataSourceInactivePatients = new MatTableDataSource<Patient>();
    // prendo i dati
    // this.dataSourceInactivePatients.data = this.inactivePatientsGlobal;
    // this.dataSourceInactivePatients.paginator = paginator;
    this.tasksInactive = this.inactivePatientsGlobal;
    this.totalSizeInactive = this.tasksInactive.length;
    this.currentPageInactive = 0;
    this.iteratorInactive();
  }
  handlePageInactive(event?: PageEvent) {
    this.currentPageInactive = event.pageIndex;
    this.pageSizeInactive = event.pageSize;
    this.iteratorInactive();
  }
  private iteratorInactive() {
    const end = (this.currentPageInactive + 1) * this.pageSizeInactive;
    const start = this.currentPageInactive * this.pageSizeInactive;
    // divido i dati nelle pagine
    this.dataSourceInactivePatients.data = this.tasksInactive.slice(start, end);
  }
  // METODI PER I CHECKOUT DEGLI INACTIVE PATIENTS
  // metodo che permette di selezionare tutti gli utenti che non hanno mai effettuato l'accesso
  // e che viene invocato al 'change' della selezione
  selectAllInactive(event: MatCheckboxChange): void {
    if (event.checked === true) { // se voglio selezionarli tutti il 'checked' è impostato su 'true'
      this.inactivePatientsGlobal.forEach(val => { // in questo caso è necessario mettere ogni check-box 'false'
        // per come è stato costruito il metodo
        val.checked = false;
      });
    } else {
      this.inactivePatientsGlobal.forEach(val => { // se voglio deselezionarli tutti il checked è impostato su'false'
        val.checked = true; // è necessario mettere ogni check-box 'true' per come è stato costruito il metodo
      });
    }
    // ogni volta inizializzo il vettore contenente le mail vuoto (evito così che ci siano mail ripetute più volte se
    // già selezionate singolarmente prima di cliccare 'seleziona tutti')
    this.patientInactiveMails = [];
    this.selectedInactive = true; // questo serve per l'html, per non ricadere nell' #elseBlock del template
    //
    // se tutti i check-box sono su 'true' metto tutte le mail in un array
    if (this.inactivePatientsGlobal.every(val => val.checked === true)) { // se voglio eliminarli tutti
      this.inactivePatientsGlobal.forEach(val => {
        val.checked = false;
        this.patientInactiveMails.pop(); // li elimino uno alla volta
      });
      console.log(this.patientInactiveMails); // controllo in console
    } else { // se voglio selezionarli tutti e quindi se tutti i check-box sono impostati su 'false'
      this.inactivePatientsGlobal.forEach(val => {
        val.checked = true;
        this.patientInactiveMails.push(val.email); // inserisco le mail nell'array una alla volta
      });
      console.log(this.patientInactiveMails); // controllo in console
    }
  }
  // metodo che permette di eliminare o aggiungere indirizzi mail nel caso in cui gli utenti siano tutti selezionati
  changeInactiveItem(event: MatCheckboxChange, element): void {
    if (event.checked === false) { // se il check-box è deselezioneto allora si toglie la mail dalla lista
      this.patientInactiveMails = this.patientInactiveMails.filter(item => item !== element.email);
      console.log(this.patientInactiveMails); // controllo in console
    } else { // se il check-box è selezionato si mette nella lista
      this.patientInactiveMails.push(element.email);
      console.log(this.patientInactiveMails); // controllo in console
    }
  }
  // metodo che viene richiamato nel template #elseBlock nel caso in cui si vogliano selezionare solo alcuni utenti
  selectInactiveItems(event: MatCheckboxChange, element): void {
    this.selectedInactive = false; // si pone a false
    if (event.checked === true) {
      this.patientInactiveMails.push(element.email); // inserisco la mail nella lista
      console.log(this.patientInactiveMails);
    } else {
      this.patientInactiveMails = this.patientInactiveMails.filter(item => item !== element.email); // tolgo la mail dalla lista
      console.log(this.patientInactiveMails);
    }
  }
  // set hovered variable of Inactive
  setHoverActiveInactiveVariable(): void {
    this.isActiveInactiveHovered = true;
  }
  // set hovereb variable false
  unsetHoverActiveInactiveVariable(): void {
    this.isActiveInactiveHovered = false;
  }

  showInfo() : void {
    if (this.isInfoShowed) 
    this.isInfoShowed=false;
    else this.isInfoShowed= true;
  }
}
